import { useSelector } from 'react-redux';
import { RootState } from '../../store/reducers';
import { isRootUser } from '../authRole';

export const useRootStatistics = () =>
    useSelector((state: RootState) => state.auth.authenticated && isRootUser(state.auth.data));
